import type { ReactNode, CSSProperties } from 'react'
import { COLORS } from '../styles/tokens'

interface PageHeaderProps {
  onBack:    () => void
  backLabel: string
  title:     string
  children?: ReactNode
}

export default function PageHeader({ onBack, backLabel, title, children }: PageHeaderProps) {
  return (
    <header style={s.header}>
      <button onClick={onBack} style={s.backBtn}>{backLabel}</button>
      <h1 style={s.title}>{title}</h1>
      {children && <div style={s.right}>{children}</div>}
    </header>
  )
}

const s: Record<string, CSSProperties> = {
  header: {
    background:  COLORS.gradientPrimary,
    padding:     '16px 24px',
    display:     'flex',
    alignItems:  'center',
    gap:         16,
  },
  backBtn: {
    fontSize:     '0.9rem',
    fontWeight:   700,
    color:        'rgba(255,255,255,0.8)',
    background:   'rgba(255,255,255,0.12)',
    border:       'none',
    borderRadius: 10,
    padding:      '8px 14px',
    cursor:       'pointer',
    minHeight:    40,
    flexShrink:   0,
  },
  title: {
    fontFamily: "'Cormorant Garamond', serif",
    fontSize:   '1.6rem',
    fontWeight: 700,
    color:      '#FFFFFF',
    margin:     0,
    flex:       1,
  },
  right: {
    display:    'flex',
    alignItems: 'center',
    gap:        8,
    flexShrink: 0,
  },
}
